import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-brand-blue text-slate-300 pt-16 pb-8 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
        {/* Column 1: Logo & Description */}
        <div className="flex flex-col gap-4">
          <Link to="/">
            <img 
              src="https://assets.auxodev.dk/cdn-cgi/image/width=360,quality=90,format=auto/assets/28021fd9-fcdc-43f4-860a-5599c796fdc7/677baf6fb33b5fd3fffc8ee2-trapezdklogo-white.png" 
              alt="Trapezdk Logo White" 
              className="h-10 w-auto object-contain mb-2"
            />
          </Link>
          <p className="text-sm text-slate-400 leading-relaxed">
            Professionel levering og montering af selvbærende højprofiler og trapezplader i højeste kvalitet.
          </p>
        </div>

        {/* Column 2: Company Info */}
        <div className="flex flex-col gap-4">
          <h3 className="text-white font-semibold text-base tracking-wide uppercase">Firma</h3>
          <div className="flex flex-col gap-2 text-sm text-slate-400">
            <span className="text-white font-medium">Trapezdk</span>
            <span>CVR: 45120562</span>
            <span>Rosbjergvej 54C</span>
            <span>8220 Brabrand</span>
          </div>
        </div>

        {/* Column 3: Contact Info */}
        <div className="flex flex-col gap-4">
          <h3 className="text-white font-semibold text-base tracking-wide uppercase">Kontakt</h3>
          <div className="flex flex-col gap-2.5 text-sm text-slate-400">
            <a href="mailto:dn@trapezdk.dk?subject=Mail%20fra%20hjemmesiden" className="hover:text-brand-orange transition-colors whitespace-nowrap">
              <i className="fa-solid fa-envelope mr-2 text-brand-orange" aria-hidden="true"></i>
              dn@trapezdk.dk
            </a>
            <a href="tel:+4522141149" className="hover:text-brand-orange transition-colors whitespace-nowrap">
              <i className="fa-solid fa-phone mr-2 text-brand-orange" aria-hidden="true"></i>
              +45 22 14 11 49
            </a>
          </div>
        </div>

        {/* Column 4: Partners & Socials */}
        <div className="flex flex-col gap-4">
          <h3 className="text-white font-semibold text-base tracking-wide uppercase">Partners & Socials</h3>
          <div className="flex flex-col gap-3 text-sm text-slate-400">
            <div>
              <a 
                href="https://sandwich-element.dk/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-brand-orange hover:underline font-medium"
              >
                SEB ApS
              </a>
            </div>
            <div className="flex gap-4 mt-2">
              <a 
                href="https://www.trapezdk.dk/#" 
                className="w-9 h-9 rounded-full bg-slate-800 flex items-center justify-center text-white hover:bg-brand-orange hover:text-white transition-all"
                aria-label="LinkedIn"
              >
                <i className="fa-brands fa-linkedin-in text-base" aria-hidden="true"></i>
              </a>
              <a 
                href="https://www.trapezdk.dk/#" 
                className="w-9 h-9 rounded-full bg-slate-800 flex items-center justify-center text-white hover:bg-brand-orange hover:text-white transition-all"
                aria-label="Facebook"
              >
                <i className="fa-brands fa-facebook-f text-base" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-8 border-t border-slate-800 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-slate-500">
        <div className="flex flex-wrap gap-x-6 gap-y-2 justify-center sm:justify-start">
          <Link to="/" className="hover:text-brand-orange transition-colors">Forside</Link>
          <Link to="/om-os" className="hover:text-brand-orange transition-colors">Om os</Link>
          <Link to="/referencer" className="hover:text-brand-orange transition-colors">Referencer</Link>
          <Link to="/tilbud" className="hover:text-brand-orange transition-colors">Indhent tilbud</Link>
        </div>
        <p className="text-center sm:text-right">
          Copyright © 2024 Trapezdk. Alle rettigheder forbeholdes.
        </p>
      </div>
    </footer>
  )
}
